import React, { useState } from "react"
import { string, array } from "prop-types"
import { useTranslation } from "next-i18next"
import BundleItem from "./BundleItem"
import styles from "./bundle-list.module.scss"
import Button from "@/components/core/Button/Button"

export const BundleList = ({ items = [], title = "" }) => {
  const [count, setCount] = useState(5)
  const { t } = useTranslation("pdp")

  const handleViewRemaining = () => {
    setCount(items.length)
  }

  return (
    items && (
      <div className={styles.bundleList}>
        {title && <div className="bundle-title">{title}</div>}
        <div className="bundle-items">
          {items.slice(0, count).map(item => (
            <div className="bundle-item__wrap" key={item.sku}>
              <BundleItem item={item} t={t} />
            </div>
          ))}
        </div>
        {items.length > 5 && count === 5 && (
          <Button
            label={`${t("kf.pdp.viewRemaining", "View Remaining")} (${
              items.length - 5
            })`}
            onClick={handleViewRemaining}
            flexible
            size="small"
            type="ghost"
            role="button"
            customClass="bundle-list__btn"
          />
        )}
      </div>
    )
  )
}
BundleList.propTypes = {
  title: string,
  items: array.isRequired,
}

BundleList.defaultProps = {
  title: "",
  items: [],
}
